import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  createCustomPropType,
  isNumeric,
  isNonEmptyString,
  isUuid,
} from '../../../../../js/app/react/validators';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { isVisible } from '../../../AdvWorkflow/AdvWorkflowHelpers';
import GoalDeleteDialog from '../../../../CommonComponents/GoalDeleteDialogView';
import Back from '../../../Navigation/Back/BackContainer';

class LargePurchaseGoalsCRUDView extends Component {
  constructor() {
    super();
    this.state = {
      canSkip: false,
      deleteGoalId: null,
    };
    this.onDelete = this.onDelete.bind(this);
    this.onCloseDeleteDialog = this.onCloseDeleteDialog.bind(this);
    this.onConfirmDelete = this.onConfirmDelete.bind(this);
  }
  UNSAFE_componentWillReceiveProps({ isPopulated, largePurchaseGoals }) {
    const { isPopulated: previousIsPopulated } = this.props;

    if (previousIsPopulated === isPopulated) {
      return;
    }

    if (largePurchaseGoals.length === 0) {
      this.setState({
        canSkip: true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      clientId,
      branch,
      iterator,
      workflowId,
      fetchData,
      onGoalEdit,
      isPopulated,
      largePurchaseGoals,
      selectedGoalId,
    } = this.props;

    if (!isVisible(prevProps.branch, prevProps.iterator) && isVisible(branch, iterator)) {
      fetchData(workflowId, clientId);
    }

    if (isPopulated && isVisible(branch, iterator) && isUuid(selectedGoalId)) {
      onGoalEdit(
        largePurchaseGoals.find(({ Id }) => Id === selectedGoalId),
        workflowId,
        clientId,
      )();
    }
  }

  onDelete(goalId) {
    return () =>
      this.setState({
        deleteGoalId: goalId,
      });
  }

  onCloseDeleteDialog() {
    this.setState({
      deleteGoalId: null,
    });
  }

  onConfirmDelete() {
    const { workflowId, clientId, largePurchaseGoals, onGoalDelete } = this.props;
    const { deleteGoalId } = this.state;
    this.setState({
      deleteGoalId: null,
    });
    onGoalDelete(deleteGoalId, largePurchaseGoals, workflowId, clientId);
  }

  render() {
    const {
      largePurchaseGoals,
      branch,
      workflowId,
      clientId,
      onAddNewGoal,
      onGoalEdit,
      getDesiredPurchaseYear,
    } = this.props;
    const { canSkip, deleteGoalId } = this.state;

    return (
      <AdvWorkflowStep branch={branch} workflowId={workflowId} canSkip={canSkip}>
        <GoalDeleteDialog
          isOpen={deleteGoalId !== null}
          onConfirmDelete={this.onConfirmDelete}
          onCloseDeleteDialog={this.onCloseDeleteDialog}
        />
        <Back workflowId={workflowId} />
        <div className="AccountsOverviewView">
          <h2 className="h2">Manage your large purchase goals</h2>
          <h3 className="h4">Add a new goal or edit an existing one</h3>
          <div className="adv-workflow-crud-widget">
            {largePurchaseGoals.length === 0 ? (
              <div className="adv-workflow-crud-empty">
                <div className="adv-workflow-crud-empty-add">
                  <button
                    className="adv-workflow-crud-empty-add-button"
                    type="button"
                    onClick={onAddNewGoal(workflowId, clientId)}
                  >
                    <i className="adv-workflow-crud-empty-add-button-i">+</i>
                    <br />
                    Add a new large purchase goal
                  </button>
                </div>
              </div>
            ) : (
              <div className="adv-workflow-crud-populated">
                <ul className="adv-workflow-crud-populated-ul">
                  {largePurchaseGoals.map(goal => {
                    const { Id, Name, Type } = goal;
                    return (
                      <li className="adv-workflow-crud-populated-li" key={Id + Name + Type}>
                        <div className="adv-workflow-crud-populated-name-2">{Name}</div>
                        <div className="adv-workflow-crud-populated-value-2">
                          {getDesiredPurchaseYear(goal)}
                        </div>
                        <div className="adv-workflow-crud-populated-actions">
                          <button
                            type="button"
                            className="adv-workflow-crud-populated-action"
                            aria-label="edit large purchase"
                            onClick={onGoalEdit(goal, workflowId, clientId)}
                          >
                            <i className="adv-workflow-crud-populated-action-i far fa-edit" />
                          </button>
                          <button
                            type="button"
                            className="adv-workflow-crud-populated-action"
                            aria-label="remove large purchase"
                            onClick={this.onDelete(Id)}
                          >
                            <i className="adv-workflow-crud-populated-action-i far fa-trash-alt" />
                          </button>
                        </div>
                      </li>
                    );
                  })}
                </ul>
                <div className="adv-workflow-crud-populated-add">
                  <button
                    className="adv-workflow-crud-populated-add-button"
                    onClick={onAddNewGoal(workflowId, clientId)}
                    type="button"
                  >
                    <i className="adv-workflow-crud-populated-add-button-i">+</i>
                    Add a new large purchase goal
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </AdvWorkflowStep>
    );
  }
}
LargePurchaseGoalsCRUDView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  isPopulated: PropTypes.bool.isRequired,
  largePurchaseGoals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onAddNewGoal: PropTypes.func.isRequired,
  onGoalDelete: PropTypes.func.isRequired,
  onGoalEdit: PropTypes.func.isRequired,
  getDesiredPurchaseYear: PropTypes.func.isRequired,
  iterator: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fetchData: PropTypes.func.isRequired,
  selectedGoalId: createCustomPropType(isUuid).isRequired,
};
export default LargePurchaseGoalsCRUDView;
